module.exports = __webpack_public_path__ + "images/emoji/truck.63690062cb944e2174d5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/truck.png
// module id = +e+D
// module chunks = 2